export default __webpack_public_path__ + "static/media/src_repairapp_m_2.e0764cef.jpg";